const getScrollTargetPath = (rootState) => rootState.ui.scroller.scrollTargetPath;

export default getScrollTargetPath;
